import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  GuardResult,
  MaybeAsync,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private loginService: LoginService, private router: Router) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): MaybeAsync<GuardResult> {
    // if the user routes to the login page but has a valid token, reroute to loggedin
    // if the user routes to the loggedin page but has an invalid token, reroute to login
    // all other routes: Those are not the droids you search for
    if (state.url === '/') {
      if (this.loginService.isLoggedIn) {
        this.router.navigate(['/loggedin/dashboard']);
        return false;
      }
      return true;
    }
    if (!this.loginService.isLoggedIn) {
      this.router.navigate(['']);
      return false;
    }
    return true;
  }
}
